import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { Sparkles } from 'lucide-react';

export default function MonitoraggioSicUpsell() {
  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              bgcolor: '#eef2ff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Sparkles size={20} color="#4f46e5" />
          </Box>
          <Box>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'text.primary' }}>
              Verifica UPSELL
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Incrocio tra contratti in essere e richieste SIC/CAI per suggerire opportunità di upsell.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Card
        sx={{
          p: 3,
          borderRadius: '16px',
          boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)'
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1.25 }}>
          Roadmap
        </Typography>
        <Box component="ul" sx={{ pl: 3, m: 0 }}>
          {[
            'Selezione pratica/cliente e periodo',
            'Incrocio contratti attivi vs richieste/esiti SIC/CAI',
            'Indicatori di opportunità (motivazione e priorità)',
            'Lista suggerimenti con azioni rapide (task/nota/contatto)'
          ].map((text) => (
            <Box component="li" key={text} sx={{ mb: 0.75 }}>
              <Typography variant="body1">{text}</Typography>
            </Box>
          ))}
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Pagina predisposta. In attesa delle specifiche funzionali.
        </Typography>
      </Card>
    </Box>
  );
}

